/**
 * @generated SignedSource<<a7915f135a418da8eb2879bd8cd8fe88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CategoryInfoEntry_entry$data = {
  readonly label: string | null | undefined;
  readonly value: string | null | undefined;
  readonly " $fragmentType": "CategoryInfoEntry_entry";
};
export type CategoryInfoEntry_entry$key = {
  readonly " $data"?: CategoryInfoEntry_entry$data;
  readonly " $fragmentSpreads": FragmentRefs<"CategoryInfoEntry_entry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryInfoEntry_entry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "CategoryInfoEntry",
  "abstractKey": null
};

(node as any).hash = "a887ee95f0423b35593939706742c432";

export default node;
